<template>
  <div class="page plr16">
    <p class="ptb16">提成配置</p>
    <div class="mains-content">
      <div class="member-content-box p16 br10" v-perm="{ key: 'deduct', value: 'deduct:list' }">
        <el-tabs class="tabs" v-model="query.queryType" type="card" @tab-click="tableChange">
          <el-tab-pane v-for="(item, index) in tabs" :label="item.title" :name="item.type" :key="index"></el-tab-pane>
        </el-tabs>

        <div class="tables">
          <el-table :data="list" :max-height="height - 220" header-cell-class-name="table_header_bgcolor"
            v-if="query.queryType == 'serve'">
            <el-table-column prop="name" label="服务名称" align="center">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column label="服务价格" align="center">
              <template slot-scope="scope">{{ scope.row.priceType == 'floating' ? scope.row.priceRange :
                scope.row.salePrice }}</template>
            </el-table-column>
            <el-table-column label="劳动提成(会员)" align="center">
              <template slot-scope="scope">{{ scope.row.workDeductAmount }}{{ scope.row.workDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <el-table-column label="劳动提成(散客)" align="center">
              <template slot-scope="scope">{{ scope.row.customerWorkDeductAmount }}{{ scope.row.workDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <el-table-column prop="deductTypeCn" label="提成类型" align="center"></el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template slot-scope="scope">
                <el-link v-show="manageModel == 'alone'" v-perm="{ key: 'deduct', value: 'deduct:update' }" type="primary"
                  @click="update('serve', scope.row)">修改</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="list" :max-height="height - 230" header-cell-class-name="table_header_bgcolor"
            v-if="query.queryType == 'product'">
            <el-table-column prop="name" label="产品名称" align="center">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column label="产品价格" align="center">
              <template slot-scope="scope">{{ scope.row.priceType == 'floating' ? scope.row.priceRange :
                scope.row.salePrice }}</template>
            </el-table-column>
            <el-table-column label="销售提成(会员)" align="center">
              <template slot-scope="scope">{{ scope.row.saleDeductAmount }}{{ scope.row.saleDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <el-table-column label="销售提成(散客)" align="center">
              <template slot-scope="scope">{{ scope.row.customerSaleDeductAmount }}{{ scope.row.saleDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <el-table-column prop="deductTypeCn" label="提成类型" align="center"></el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template slot-scope="scope">
                <el-link v-show="manageModel == 'alone'" type="primary" v-perm="{ key: 'deduct', value: 'deduct:update' }"
                  @click="update('product', scope.row)">修改</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="list" :max-height="height - 230" header-cell-class-name="table_header_bgcolor"
            v-if="query.queryType == 'card'">
            <el-table-column prop="name" label="卡项名称" align="center">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column label="卡项价格" align="center">
              <template slot-scope="scope">{{ scope.row.priceType == 'floating' ? scope.row.priceRange :
                scope.row.salePrice }}</template>
            </el-table-column>
            <el-table-column label="劳动提成" align="center">
              <template slot-scope="scope">{{ scope.row.workDeductAmount }}{{ scope.row.workDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <el-table-column label="销售提成" align="center">
              <template slot-scope="scope">{{ scope.row.saleDeductAmount }}{{ scope.row.saleDeductWay ==
                'fixed' ? '元' : '%' }}</template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="update('card',scope.row)">修改</el-link>
              </template>
            </el-table-column>-->
          </el-table>
          <el-table :data="list" :max-height="height - 230" header-cell-class-name="table_header_bgcolor"
            v-if="query.queryType == 'recharge'">
            <el-table-column label="提成规则" align="center">
              <template slot-scope="scope">{{ '￥' + scope.row.startInterval }} - {{ scope.row.endInterval }}</template>
            </el-table-column>
            <el-table-column label="提成价格" align="center">
              <template slot-scope="scope">{{ scope.row.deductValue }} {{ scope.row.deductWay ==
                'ratio' ? '%' : '元' }}</template>
            </el-table-column>
            <el-table-column prop="deductTypeCn" label="充值类型" align="center">
              <template slot-scope="scope">{{ scope.row.deductTypeCn }}</template>
            </el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template slot-scope="scope">
                <!-- joinType == 'union' -->
                <el-link v-show="manageModel == 'alone'" type="primary" @click="update('recharge', scope.row)"
                  v-perm="{ key: 'deduct', value: 'deduct:update' }">修改</el-link>&nbsp;&nbsp;
                <el-link v-show="joinType == 'union'" type="primary" @click="deleteItem(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-button class="btn-button" type="primary" v-if="query.queryType == 'recharge' && joinType == 'union'"
          @click="add('recharge')">新增提成</el-button>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="editChange"></edit-set>
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import detailSet from "./detail";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      joinType: "",
      manageModel:"",
      isSuperManage: null,
      url: this.$url.deduct.listForShop,
      query: {
        queryType: "serve",
        size: 20,
        start: 1
      },
      tabs: [
        {
          type: "serve",
          title: "服务项目"
        },
        {
          type: "product",
          title: "产品"
        },
        {
          type: "card",
          title: "卡项"
        },
        {
          type: "recharge",
          title: "充值"
        }
      ],
      height: this.$store.getters.MainHeight,
    };
  },
  components: {
    editSet,
    detailSet
  },
  created() {
    // this.totalCounts();
    this.getData();
    this.$api.get(this.$url.companyStaff.currentStaff).then(res => {
      if (res) {
        console.log(res.joinType);
        console.log(res.superManage);
        console.log(res.manageModel);
        this.isSuperManage = res.superManage;
        this.joinType = res.joinType;
        this.manageModel = res.manageModel
      }
    });

  },

  methods: {
    back() {
      this.$router.push("/dataList");
    },
    tableChange(val) {
      // Object.assign(this.$data, this.$options.data());
      this.list = [];
      this.query.queryType = val.name;

      if (val.name == 'recharge') {
        this.url = this.$url.deduct.listRechargeRule;
      } else {
        this.url = this.$url.deduct.listForShop;
      }
      this.query.start = 1;
      // this.totalCounts();
      this.getData();

    },
    editChange(bool) {
      // this.totalCounts();
      this.getData();
    },
    update(type, item) {
      this.$refs["editSetForm"].$emit("set", {
        type: type,
        item: item
      });
    },
    add(type) {
      this.$refs["editSetForm"].$emit("set", {
        type: type,
        item: 'add'
      });
    },
    detailPage(item) {
      this.$refs["detailSetForm"].$emit("set", item);
    },
    deleteItem(item) {
      this.$confirm('确定删除此条提成数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.post(this.$url.deduct.deleteRechargeRule, { rechargeRuleId: item.id }).then(res => {
          if (res) {
            this.$message.success("删除成功")
            this.getData();
          }
        });
      }).catch(() => {

      });
    },
    totalCounts() {
      this.$api.post(this.$url.deduct.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.mains-content {
  height: 100%;

  .member-content-box {
    position: relative;
    background: #fff;

    .btn-button {
      position: absolute;
      right: 16px;
      top: 16px;
    }
  }
}

/deep/.el-tabs--card>.el-tabs__header .el-tabs__item {
  font-size: 16px;
  font-weight: 500;
}

.member-header {
  background: #fff;
  height: 56px;
  padding: 0 25px;
  display: flex;
  align-items: center;
}
</style>